import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import Store from 'store/store';
import 'store/bolt/header';
import { accessNested, joinClasses } from 'utils/utils';
import { getPercentageThreshold } from 'utils/visibilityChecks';
import { getIsSinglePageIframed } from 'utils/bolt/client';
import Button from 'components/bolt/button/button';
import BurgerMenu from 'components/bolt/burgerMenu/burgerMenu';
import Reset from 'components/bolt/icons/reset';
import HeaderExpanded from 'components/bolt/header/headerExpanded';
import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {

	getCurrentHeaderAction() {
		let actions = this.props.headerData.actions;
		let customBurgerMenu;
		if (typeof document !== 'undefined') {
			customBurgerMenu = accessNested(this.props.appData, 'header.powsterHeader.customBurgerMenu', null);
		}
		const customPath = customBurgerMenu?.path;
		const activePage = Store.get()?.activePage;
		const pages = Store.get()?.appData?.pages;
		if (pages[activePage].component === 'quizPhotobooth') {
			const quizPhotobooth = Store.get().quizPhotobooth;
			const shouldBeReset = quizPhotobooth?.step === 'shareable' || (quizPhotobooth?.step === 'quiz' && quizPhotobooth?.showResultPage);
			if (quizPhotobooth?.step === 'quiz' && quizPhotobooth?.question !== 0) {
				return {
					icon: 'back',
					action: () => Store.emit('QUIZPHOTOBOOTH_PREV_QUESTION', true),
					hidden: false
				};
			} else if (shouldBeReset) {
				return {
					icon: 'back',
					action: () => {
						Store.emit('QUIZPHOTOBOOTH_QUIZ_RESET', true);
						Store.emit('QUIZPHOTOBOOTH_SHAREABLE_RESET', true);
						Store.emit('QUIZPHOTOBOOTH_BACK_TO_INTRO', true);
					},
					hidden: false
				};
			} else if (quizPhotobooth?.step && quizPhotobooth?.step !== 'intro') {
				return {
					icon: 'back',
					action: () => {
						Store.emit('QUIZPHOTOBOOTH_BACK', true);
						Store.emit('QUIZPHOTOBOOTH_PREV_QUESTION_CLICKED');
					},
					hidden: false
				};
			}
		}
		
		if (customPath?.startsWith('http')) {
			return {
				action: () => window.open(customPath, '_blank')
			};
		}

		return actions[actions.length - 1] || {
			icon: 'burger',
			action: this.openNavMenu
		};

	}

	render(props) {
		const {
			appData,
			headerData,
			isCalendarRemindMode,
			client,
			solidBackground,
			desktopSolidHeader,
			style,
			offsetTop,
			calRemindOpen
		} = props;
		const { copy } = appData;
		const {
			showtimesOverlay,
			homeEntOverlay,
			pressKitOverlay,
			homeEntMerchantOpen,
			activeSection,
			videoOverlayOpen,
			showtimesSearchOverlay,
			open: navOpen,
			shareOpen,
			interstitialOpen,
			hubTextOverlayOpen,
		} = headerData || {};

		const store = Store.get();
		const isMobile = accessNested(this.props, 'client.device', '') !== 'desktop';
		const homeActive = isMobile ? Store.get().activePage === 'boltHome' : accessNested(store, 'homeActivePercentage', 1) > getPercentageThreshold(offsetTop);

		const locationClassName = videoOverlayOpen ? 'boltVideos' : (activeSection || 'bolt');
		const actionData = this.getCurrentHeaderAction();

		const regionSelector = this.renderRegionSelector();
		const regionSelectorEnabled = typeof accessNested(appData, 'header.powsterHeader.regionSelector') !== 'undefined';
		// Should be set at studio level
		const { regionSelectorShowing } = this.state;

		const fontStyles = accessNested(this.props, 'appData.styling.fontVariables');

		const oneSheetOverlay = accessNested(store, 'synopsis.onesheetExpanded');
		// TODO: let trailerOverlay component itself handle hiding the burger menu if needed to better match the behaviour
		const trailerOverlayOpen = store.trailerOverlay?.overlayOpen && store.trailerOverlay?.data?.video;

		// const headerLogo = accessNested(appData, 'header.powsterHeader.logo', false);
		// const headerLogoExclusions = (headerLogo?.pageExclusions || '').split(',')?.map(e => e.trim())?.filter(e => e);
		// const hideHeaderLogo = headerLogoExclusions.includes(store.activePage);
		const hideBurgerMenu = accessNested(Store.get(), 'appData.options.disableBurgerMenu', false);
		const isDesktopSize = accessNested(this.props, 'client.isDesktopSize');


		let containerStyle = {};
		if (offsetTop) {
			containerStyle.position = 'fixed';
			containerStyle.top = offsetTop + 'px';
			containerStyle.zIndex = 9;
		}

		let sonyHeader = this.renderSonyHeader();

		if (!accessNested(this.props, 'appData.header.powsterHeader')) {
			return sonyHeader;
		}

		let burgerMenuAriaLabel;

		// Should probably set the Aria label when setting the action (when calling SET_HEADER_ACTION)
		if (actionData.icon === 'burger') {
			burgerMenuAriaLabel = copy.accessibilityCopy.$OPEN_NAV_ARIA;
		} else if (actionData.tag === 'closeNavMenu') {
			burgerMenuAriaLabel = copy.accessibilityCopy.$CLOSE_NAV_ARIA;
		} else if (actionData.tag === 'closeOnesheetOverlay') {
			burgerMenuAriaLabel = copy.accessibilityCopy.$CLOSE_ONESHEET_ARIA;
		} else if (actionData.tag === 'closeCalRemind') {
			burgerMenuAriaLabel = copy.accessibilityCopy.$CALENDAR_REMINDER_CLOSE_ARIA;
		} else if (actionData.tag === 'closeVideoOverlay') {
			burgerMenuAriaLabel = copy.accessibilityCopy.$CLOSE_VIDEOS_ARIA;
		} else if (actionData.icon === 'back') {
			burgerMenuAriaLabel = copy.accessibilityCopy.$BACK_BTN_SHOWTIMES_ARIA;
		}

		const navDisabled = !this.props?.appData?.header?.powsterHeader?.nav;
		const isSinglePageIframed = getIsSinglePageIframed();
		const menuText = copy.baseCopy.$NAVIGATION_LABEL;
		const showMenuText = menuText && !showtimesOverlay && !homeEntOverlay && !videoOverlayOpen && !navDisabled;
		const providerInterstitialOpen = accessNested(store, 'showtimes.providerInterstitialOpen', false) || accessNested(store, 'previewPanel.providerInterstitialOpen', false);

		const sectionSpecificStyle = this.getSectionSpecificStyle();
		const navLabelStyle = {};
		if (sectionSpecificStyle) {
			const { headerNavLabel } = sectionSpecificStyle;
			navLabelStyle.color = headerNavLabel;
		}

		const burgerStyle = {};
		if (sectionSpecificStyle && !headerData.open) {
			const { headerNavIconOpen, headerNavIconOpenMob } = sectionSpecificStyle;
			burgerStyle.background = (headerNavIconOpenMob && !isDesktopSize) ? headerNavIconOpenMob : headerNavIconOpen;
		}

		const isBurgerIcon = !actionData.icon || actionData.icon === 'burger';

		const quizPhotobooth = Store.get().quizPhotobooth;
		const activePage = Store.get()?.activePage;
		const pages = Store.get()?.appData?.pages;
		const pageIsQuizPhotobooth = pages[activePage].component === 'quizPhotobooth';
		const shouldBeResetIcon = pageIsQuizPhotobooth && (quizPhotobooth?.step === 'shareable' || (quizPhotobooth?.step === 'quiz' && quizPhotobooth?.showResultPage));

		const customBurgerMenu = accessNested(store, 'appData.header.powsterHeader.customBurgerMenu', null);

		return (
			<div
				class={joinClasses(`header-${store.activePage}`, navOpen && 'navOpen', {
					s,
					headerContainer: true,
					homeEntMerchantOpen
				})}
			>
				{sonyHeader}
				<div
					class={
						joinClasses({
							s,
							container: true,
							showtimesSearchOverlay,
							solidBackground,
							desktopSolidHeader,
							hubTextOverlayOpen,
						}, s[`activeSection--${locationClassName}`])
					}
					style={containerStyle}
					key="container"
					id="header"
				>
					<Button
						class={joinClasses(
							s.burgerMenuBtn,
							(shareOpen || regionSelectorShowing || navDisabled || providerInterstitialOpen || hideBurgerMenu && isBurgerIcon) && s.hide,
							isSinglePageIframed && s.disabled
						)}
						trigger={this.triggerBurgerBtn}
						ariaLabel={burgerMenuAriaLabel}
						key="burgerButton"
					>
						{shouldBeResetIcon ? (
							<Reset class={joinClasses(s.share, s.reset)} />
						) : (
							<BurgerMenu
								type={actionData.icon || 'burger'}
								dark={actionData.dark}
								style={actionData.style}
								hidden={interstitialOpen}
								lineStyle={burgerStyle}
								showtimesOverlayOpen={showtimesOverlay}
								homeEntOverlayOpen={homeEntOverlay}
								pressKitOverlayOpen={pressKitOverlay}
								isSinglePageIframed={isSinglePageIframed}
								homeScrolled={!homeActive}
								navOpen={navOpen}
								showtimesSearchOverlay={showtimesSearchOverlay}
								videoOverlayOpen={videoOverlayOpen}
								oneSheetOverlayOpen={oneSheetOverlay}
								trailerOverlayOpen={trailerOverlayOpen}
								calendarRemindOpen={calRemindOpen}
								widgetFullyExpanded={store.widgetFullyExpanded}
								customBurgerMenu={customBurgerMenu}
							/>
						)}
					</Button>
					{this.renderHeaderLogo()}
					{!!showMenuText && (
						<span class={joinClasses(s.menuText, fontStyles.headerShare, { s, homeScrolled: !homeActive })} style={navLabelStyle} onClick={this.triggerBurgerBtn}>
							{menuText}
						</span>
					)}
					{this.renderExtraActions()}
					{this.renderPersistentButton()}
					{this.renderShare()}
					<HeaderExpanded
						appData={appData}
						activePage={props.activePage}
						headerData={headerData}
						navOpen={navOpen}
						client={client}
						isCalendarRemindMode={isCalendarRemindMode}
						showRegionSelector={regionSelector && regionSelectorEnabled}
						regionSelectorClick={this.toggleRegionSelector}
						style={style}
						key="expand"
					/>
					{regionSelector}
				</div>
			</div>
		);
	}
}
